import { InsightsFiltersOptionsQuery } from 'generated/resources/graphql'
import { orderBy } from 'lodash'

import { makeEmployeeOptions } from 'modules/core/components/Filter/filters/premade/employeeOptions'
import { useUnsafeMemo } from 'modules/core/hooks/useMemo'
import { type Users } from 'modules/core/store/collections/users'

export const useManagerOptions = (
  filtersOptionsData: InsightsFiltersOptionsQuery,
  users: Users
) => {
  const options = useUnsafeMemo(
    () =>
      orderBy(
        makeEmployeeOptions(filtersOptionsData.employees.employees, users),
        (option) => option.label,
        'asc'
      ),
    [filtersOptionsData, users]
  )

  return options
}
